import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestApiService } from '@app-services/rest/rest-api.service';

//import { getRemoteConfig } from "firebase/remote-config";
//import { getValue } from "firebase/remote-config";
//import { fetchAndActivate } from "firebase/remote-config";
//import { getAll } from "firebase/remote-config";

import firebase from "firebase/app";
import "firebase/remote-config";
import * as moment from 'moment';
import { LoginService } from '@app-services/login/login.service';
import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from 'ngx-webstorage';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { states } from '@subscription-constants/subscriptionconstant';
import { CourseService } from 'src/app/core/services/course.service';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService extends RestApiService {
  imageUrl = "";
  redirectUrl = "";
  displayExamName = "";
  gradeName = "";
  states = states;
  constructor(http: HttpClient, storage: LocalStorageService, gaService: GAnalyticsService, private loginService: LoginService,private courseService: CourseService) {
    super(http, storage, gaService);
  }
  geDashboardData(): Observable<any> {
    // const url = this.apiUrl + `/api/boards`;
    const url = `assets/data/dashboard.json`;
    console.log(url)
    return this.get<any>(url);
  }

  //const app =  firebase.initializeApp(firebaseConfig);


  async getImageData(displayExamName, gradeName) {
    //const remoteConfig = getRemoteConfig();
    const remoteConfig = firebase.remoteConfig();
    remoteConfig.settings.minimumFetchIntervalMillis = 1000;
    this.displayExamName = displayExamName;
    this.gradeName = gradeName;
    //return fetchAndActivate(remoteConfig)
    return remoteConfig.fetchAndActivate()
      .then(() => {
        var currentPage = localStorage.getItem('currentPage');
        let grade = this.gradeName;
        const replacements = [
          { find: "st", replaceWith: "" },
          { find: "nd", replaceWith: "" },
          { find: "th", replaceWith: "" }
        ];
        for (const replacement of replacements) {
          const regex = new RegExp(replacement.find, "g");
          grade = grade.replace(regex, replacement.replaceWith);
        }
        var key = this.displayExamName.replace(' ', '_').toLowerCase() + '_' + `grade_` + grade + '_' + currentPage;
        console.log("key: " + key);
        var val = remoteConfig.getValue(key);
        return JSON.parse(val.asString());
      }).catch((err) => {
        return JSON.parse("{}");
      });
  }

  async getWhatsNewData(displayExamName, gradeName) {
    //const remoteConfig = getRemoteConfig();
    const remoteConfig = firebase.remoteConfig();
    remoteConfig.settings.minimumFetchIntervalMillis = 1000;
    //return fetchAndActivate(remoteConfig)
    return remoteConfig.fetchAndActivate()
      .then(() => {
        let map = new Map();
        var currentPage = localStorage.getItem('currentPage');
        var key = this.displayExamName.replace(' ', '_').toLowerCase() + '_' + `grade_` + this.gradeName.replace('th', '') + '_' + currentPage;
        console.log("key: " + key);
        var whatsnewWebKey1 = key + '_whatsnew1_web';
        //var whatsnewWeb1 = getValue(remoteConfig, whatsnewWebKey1);
        var whatsnewWeb1 = remoteConfig.getValue(whatsnewWebKey1);
        map.set("whatsnewWeb1", JSON.parse(whatsnewWeb1.asString()));
        var whatsnewMobKey1 = key + '_whatsnew1_mob';
        // var whatsnewMob1 = getValue(remoteConfig, whatsnewMobKey1);
        var whatsnewMob1 = remoteConfig.getValue(whatsnewMobKey1);
        map.set("whatsnewMob1", JSON.parse(whatsnewMob1.asString()));

        //var whatsnew3 = getValue(remoteConfig, "whatsnew3");
        var whatsnew3 = remoteConfig.getValue('whatsnew3');
        map.set("whatsnew3", JSON.parse(whatsnew3.asString()));

        // var whatsnewWebKey2 = key+'_whatsnew2_web';
        // var whatsnewWeb2 = getValue(remoteConfig, whatsnewWebKey2);
        // resp.push(JSON.parse(whatsnewWeb2.asString()));
        // var whatsnewMobKey2 = key+'_whatsnew2_mob';
        // var whatsnewMob2 = getValue(remoteConfig, whatsnewMobKey2);
        // resp.push(JSON.parse(whatsnewMob2.asString()));

        //  var whatsnew1 = getValue(remoteConfig, "whatsnew1");
        //  resp.push(JSON.parse(whatsnew1.asString()));
        //  var whatsnew2 = getValue(remoteConfig, "whatsnew2");
        //  resp.push(JSON.parse(whatsnew2.asString()));
        //  var whatsnew3 = getValue(remoteConfig, "whatsnew3");
        //  resp.push(JSON.parse(whatsnew3.asString()));
        return map;
      }).catch((err) => {
        return JSON.parse("{}");
      });

  }
  async getFireBaseEventUserDetails() {
    let currentDate = moment().format('DD/MM/YYYY');
    let userData = JSON.parse(localStorage.getItem('user_details_from_server'));
    await this.loginService.getAddressList(userData.userId).subscribe((res: any) => {
      var myobjdata = {
        date: currentDate,
        grade: userData?.grade?.gradeId,
        target_exam: localStorage.getItem('targetExamName'),
        board: userData?.board?.name,
        city: res.response.cityName,
        platform: "web",
        mobile: userData?.phone

      }
      return myobjdata;
    });
  };
  getFireBaseEventUserDetailsPromise(hasClass?) {
    let courseName,language,subjects,imageUrl;
    let exams = [];
   return new Promise((resolve,reject)=>{
      let userData = JSON.parse(localStorage.getItem('user_details_from_server'));
      let currentSate = states?.find(obj=>obj?.abbreviation == userData?.regionId); //?currentstates by resgionID
      let exam = localStorage.getItem('targetExamName');
      userData?.exams?.forEach(element => {
          exams.push(element?.name)
      });
      this.loginService.getAddressList(userData.userId).subscribe((res: any) => {
        let indexToSelect = (res?.response?.length - 1) //?selecting to latest ones
        let myobjdata = {
          // date: currentDate,
          state:currentSate?.name,
          grade:parseInt(userData?.grade?.name),
          target_exam: localStorage.getItem('targetExamName'),
          board: userData?.board?.name,
          city: res?.response?.[indexToSelect]?.cityName,
          platform: "web",
          mobile: userData?.phone,
          exam:exam,
          exams:exams.join(','),
          stream:userData?.stream?.name,
          courseName:courseName?courseName:null,
          language:language?language:null,
          subjects:subjects?subjects:null,
          imageUrl:imageUrl?imageUrl:null,
        };
        if(hasClass){
          this.courseService.getCourseDetails(hasClass).subscribe((res:any)=>{
            courseName = res?.data?.name
            subjects = res?.data?.subjects
            language = res?.data?.language;
            imageUrl = res?.data?.batches?.[0]?.batchPicture
            myobjdata = {
              // date: currentDate,
              state:currentSate?.name,
              grade:parseInt(userData?.grade?.name),
              target_exam: localStorage.getItem('targetExamName'),
              board: userData?.board?.name,
              city: res?.response?.[indexToSelect]?.cityName,
              platform: "web",
              mobile: userData?.phone,
              exam:exam,
              exams:exams.join(','),
              stream:userData?.stream?.name,
              courseName:courseName?courseName:null,
              language:language?language:null,
              subjects:subjects?subjects:null,
              imageUrl:imageUrl?imageUrl:null,
            };
            resolve(myobjdata);
          },
          (err: any) => {
            resolve(myobjdata);
          })
        }else{
          resolve(myobjdata);
        }
      });
    })
    // let currentDate = moment().format('DD/MM/YYYY');

  }
  async getSqsValue() {
    //const remoteConfig = getRemoteConfig();
    const remoteConfig = firebase.remoteConfig();
    remoteConfig.settings.minimumFetchIntervalMillis = 1000;
    //return fetchAndActivate(remoteConfig)
    return remoteConfig.fetchAndActivate()
      .then(() => {
        var key = 'unified_lsq_config'
        //var val = getValue(remoteConfig, key);
        var val = remoteConfig.getValue(key);
        return JSON.parse(val.asString());
      }).catch((err) => {
        return JSON.parse("{}");
      });
  }

  async getWebsiteSqsValue() {
    //const remoteConfig = getRemoteConfig();
    const remoteConfig = firebase.remoteConfig();
    remoteConfig.settings.minimumFetchIntervalMillis = 1000;
    //return fetchAndActivate(remoteConfig)
    return remoteConfig.fetchAndActivate()
      .then(() => {
        var key = 'website_lsq_config'
        //var val = getValue(remoteConfig, key);
        var val = remoteConfig.getValue(key);
        return JSON.parse(val.asString());
      }).catch((err) => {
        return JSON.parse("{}");
      });
  }
}

